<div class="app-radio-box-container" [class.disabled]="disabled">
  <label *ngIf="label" class="radio-box-label">{{ label | translate }}</label>

  <div class="radio-options" [class.horizontal]="direction === 'horizontal'" [class.vertical]="direction === 'vertical'">
    <!-- All Option -->
    <div class="radio-option" *ngIf="showAll">
      <p-radioButton
        [name]="name"
        [value]="null"
        [(ngModel)]="value"
        (ngModelChange)="onValueChange($event)"
        [disabled]="disabled"
        [inputId]="name + '-all'"
      ></p-radioButton>
      <label [for]="name + '-all'" class="radio-label">{{ allLabel | translate }}</label>
    </div>

    <!-- Yes Option -->
    <div class="radio-option" *ngIf="showYes">
      <p-radioButton
        [name]="name"
        [value]="true"
        [(ngModel)]="value"
        (ngModelChange)="onValueChange($event)"
        [disabled]="disabled"
        [inputId]="name + '-yes'"
      ></p-radioButton>
      <label [for]="name + '-yes'" class="radio-label">{{ yesLabel | translate }}</label>
    </div>

    <!-- No Option -->
    <div class="radio-option" *ngIf="showNo">
      <p-radioButton
        [name]="name"
        [value]="false"
        [(ngModel)]="value"
        (ngModelChange)="onValueChange($event)"
        [disabled]="disabled"
        [inputId]="name + '-no'"
      ></p-radioButton>
      <label [for]="name + '-no'" class="radio-label">{{ noLabel | translate }}</label>
    </div>
  </div>
</div>
